// ---------------------------
// src/LanguageSelector.js (style-safe tweak)
// Keeps functionality. Trigger/menu classes match App.css hooks.
// ---------------------------
import React, { useEffect, useRef, useState } from "react";

const LANGS = [
  { key: "en", label: "English" },
  { key: "fr", label: "Français" },
  { key: "de", label: "Deutsch" },
  { key: "es", label: "Español" },
  { key: "it", label: "Italiano" },
];

export default function LanguageSelector({ value = "en", onChange, showLabel = true }){
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find(l => l.key === value) || LANGS[0];

  useEffect(() => {
    const onDocClick = (e) => { if (!ref.current || ref.current.contains(e.target)) return; setOpen(false); };
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => { document.removeEventListener("click", onDocClick); document.removeEventListener("keydown", onEsc); };
  }, []);

  return (
    <div className="relative flex items-center gap-2" ref={ref}>
      {showLabel && <span className="lang-label text-sm">Language:</span>}

      <button
        type="button"
        onMouseDown={(e)=>e.preventDefault()}
        className="lang-trigger px-3 py-2 rounded-lg bg-white border border-slate-200 pl-3 pr-8 text-brand text-sm hover:bg-slate-50 transition outline-none focus:ring-2 focus:ring-indigo-300"
        aria-haspopup="listbox" aria-expanded={open}
        onClick={()=> setOpen(o=>!o)}
      >
        {current.label}
        <span className="ml-1 inline-block align-middle select-none">▾</span>
      </button>

      {open && (
        <ul role="listbox" className="lang-menu absolute right-0 top-full mt-2 w-40 z-50 bg-section rounded-md shadow-none p-1 outline-none">
          {LANGS.map((l)=> (
            <li key={l.key}>
              <button type="button" role="option" aria-selected={l.key===value}
                className={`w-full text-left px-3 py-2 rounded-md text-sm ${l.key===value ? 'bg-[#E9EEF6] text-brand' : 'text-brand'} hover:bg-[#E9EEF6]`}
                onClick={()=>{ onChange?.(l.key); setOpen(false); }}>
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
